import { Folder, GitCompareArrows, House, ReceiptText, ScanSearch } from "lucide-react"

import { NavigationSectionModel } from "@/models/navigation"

export const APPLICATION_SECTION: NavigationSectionModel = {
        title: "Application",
        items: [
                { title: "Dashboard", tooltip: "Dashboard", url: "/", icon: House },
                { title: "Search", tooltip: "Search", url: "/search", icon: ScanSearch }
        ]
}

export const ADVANCED_SECTION: NavigationSectionModel = {
        title: "Advanced",
        items: [
                { title: "Applications", tooltip: "Applications", url: "/applications", icon: ReceiptText },
                { title: "AI Generation", tooltip: "Report Generation", url: "/report-generator", icon: Folder },
                { title: "Document Comparison", tooltip: "Document Comparison", url: "/compare", icon: GitCompareArrows },
        ]
}